export default "<app-dialog-promo [appType]=\"appType\" [dataModal]=\"dataModal\"></app-dialog-promo>";